import styles from "./PlusIcon.module.scss";

import PlusIconSvg from "./plus-thin-bold.svg";

interface IPlusIconProps {
    id?: string;
    dataCy?: string;
}

/**
 * @deprecated Will be replaced when storybook is merged
 */
function PlusThinIcon(props: IPlusIconProps): JSX.Element {
    return (
        <span
            id={props.id}
            data-cy={props.dataCy}
            className={`${styles.iconBase} ${styles.md}`}
        >
            <PlusIconSvg />
        </span>
    );
}
export { PlusThinIcon };
